(() => {
  var LABELS = {
    need: { thick: 'Dicke/harte Fußnägel', corner: 'Nagelecken', normal: 'Normale Fußnägel', finger: 'Fingernägel' },
    force: { low: 'Wenig Kraftaufwand', normal: 'Normaler Kraftaufwand' },
    user: { self: 'Ich selbst', other: 'Andere Person', pro: 'Professionell' }
  };
  var QUESTIONS = { need: 'Einsatzbereich', force: 'Kraftaufwand', user: 'Anwender' };

  /* Event an alle Web-Pixel (Custom Pixel "Produktfinder GA4") + dataLayer (falls spaeter GTM) */
  function track(name, data) {
    var payload = Object.assign({ finder: 'produktfinder_home' }, data || {});
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
  }

  /* Warenkorb-Attribute setzen -> erscheinen in der Bestellung unter "Zusaetzliche Details" */
  function setCartAttributes(url, attrs, keepalive) {
    try {
      var opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      };
      if (keepalive) opts.keepalive = true;
      return fetch(url || '/cart/update.js', opts).catch(function () {});
    } catch (e) {}
  }

  document.querySelectorAll('[data-nzf-root]').forEach(function (root) {
    if (root.dataset.nzfReady) return;
    root.dataset.nzfReady = '1';
    var cartUpdateUrl = root.dataset.nzfCartUpdate || (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    var s = { need: null, force: null, user: null };
    var steps = [].slice.call(root.querySelectorAll('[data-step]'));
    var res = root.querySelector('[data-nzf-result]');
    var bar = root.querySelector('[data-nzf-progress]');
    var lab = root.querySelector('[data-nzf-step-label]');
    var pct = root.querySelector('[data-nzf-step-percent]');
    var stepTpl = root.dataset.nzfStepTpl || 'Frage %N% von 3';
    var resultLabel = root.dataset.nzfResultLabel || 'Ihre Empfehlung';
    var started = false;
    var current = null; /* aktuelles Ergebnis fuer Klick-Tracking */

    function answersText() {
      return ['need', 'force', 'user'].filter(function (k) { return s[k]; })
        .map(function (k) { return (LABELS[k] && LABELS[k][s[k]]) || s[k]; }).join(' | ');
    }
    function answersCode() {
      return [s.need || '-', s.force || '-', s.user || '-'].join('/');
    }
    function show(n) {
      steps.forEach(function (e) { e.hidden = +e.dataset.step !== n; });
      res.hidden = true;
      var p = Math.round(n / 3 * 100);
      bar.style.width = p + '%';
      lab.textContent = stepTpl.replace('%N%', n);
      pct.textContent = p + ' %';
    }
    function key() {
      if (s.user === 'pro') return 'pro';
      if (s.need === 'corner') return 'corner';
      if (s.need === 'finger') return 'finger';
      if (s.need === 'normal') return 'normal';
      if (s.need === 'thick' && s.user === 'other') return 'thick_other';
      if (s.need === 'thick' && s.force === 'low') return 'thick_easy';
      return 'thick_value';
    }
    function render() {
      var k = key();
      var t = root.querySelector('[data-result-template="' + k + '"]') || root.querySelector('[data-result-template="thick_easy"]');
      if (!t) return;
      steps.forEach(function (e) { e.hidden = true; });
      res.hidden = false;
      bar.style.width = '100%';
      lab.textContent = resultLabel;
      pct.textContent = '100 %';
      root.querySelector('[data-result-title]').textContent = t.dataset.title || '';
      root.querySelector('[data-result-price]').textContent = t.dataset.price || '';
      root.querySelector('[data-result-reason]').textContent = t.dataset.reason || '';
      root.querySelector('[data-result-link]').href = t.dataset.url || '#';
      root.querySelector('[data-result-more]').href = t.dataset.more || '#';
      root.querySelector('[data-result-media]').innerHTML = t.innerHTML;
      root.querySelector('[data-result-benefits]').innerHTML = (t.dataset.benefits || '').split('|').filter(Boolean).map(function (x) { return '<li>' + x + '</li>'; }).join('');

      current = {
        result_key: k,
        product_id: t.dataset.productId || '',
        product_handle: t.dataset.handle || '',
        product_title: t.dataset.title || '',
        product_url: t.dataset.url || '',
        answers: answersCode(),
        answers_text: answersText()
      };

      track('produktfinder_result', current);

      try {
        sessionStorage.setItem('nzf_result', JSON.stringify(Object.assign({ ts: Date.now() }, current)));
      } catch (e) {}

      setCartAttributes(cartUpdateUrl, {
        'Produktfinder': 'Ja',
        'Produktfinder Empfehlung': current.product_title,
        'Produktfinder Produkt-ID': current.product_id,
        'Produktfinder Antworten': current.answers_text,
        'Produktfinder Klick': ''
      });
    }

    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-answer]');
      if (c) {
        var q = c.dataset.answer;
        s[q] = c.dataset.value;
        var n = +c.closest('[data-step]').dataset.step;
        if (!started) {
          started = true;
          track('produktfinder_start', { first_answer: c.dataset.value });
        }
        track('produktfinder_answer', {
          step: n,
          question: QUESTIONS[q] || q,
          answer: c.dataset.value,
          answer_text: (LABELS[q] && LABELS[q][c.dataset.value]) || c.dataset.value
        });
        n < 3 ? show(n + 1) : render();
        return;
      }
      var link = e.target.closest('[data-nzf-click]');
      if (link && current) {
        var target = link.dataset.nzfClick; /* produkt | weitere */
        track('produktfinder_click', Object.assign({ click_target: target, href: link.getAttribute('href') || '' }, current));
        setCartAttributes(cartUpdateUrl, { 'Produktfinder Klick': target === 'produkt' ? 'Produkt ansehen' : 'Weitere Produkte' }, true);
        return;
      }
      if (e.target.closest('[data-nzf-back]')) {
        show(Math.max(1, +e.target.closest('[data-step]').dataset.step - 1));
        return;
      }
      if (e.target.closest('[data-nzf-restart]')) {
        track('produktfinder_restart', current || {});
        s.need = s.force = s.user = null;
        current = null;
        show(1);
      }
    });
  });
})();
